import { stats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="home" className="relative w-full min-h-[720px] md:min-h-[760px] py-24 md:py-28 overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20editorial%20scene%20of%20a%20single%20dramatic%20spotlight%20beam%20cutting%20through%20warm%20dark%20haze%20over%20a%20minimal%20desk%20with%20scattered%20paper%20documents%2C%20deep%20crimson%20and%20amber%20tones%2C%20strong%20chiaroscuro%20contrast%2C%20cinematic%20atmosphere%2C%20dark%20foreground%20for%20text%20readability%2C%20highly%20stylized%20artistic%20composition%2C%20no%20recognizable%20faces&width=1800&height=1100&seq=juguangtai-hero-01&orientation=landscape"
          alt="聚光台网红爆料线索中心的聚光灯抽象背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/70 to-foreground-950/85"></div>

      <div className="relative z-10 w-full h-full px-4 md:px-10 flex flex-col justify-center">        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-accent-400/60 bg-accent-500/15 text-accent-200 text-xs md:text-sm tracking-wide animate-fade-in">
            <i className="ri-record-circle-line"></i>
            匿名投稿通道 · 持续开放中
          </span>

          <h1 className="mt-5 md:mt-7 font-heading text-3xl md:text-[52px] md:leading-[1.15] font-bold text-background-50">
            让每一条爆料，
            <span className="text-accent-400">都有据可查</span>
          </h1>

          <p className="mt-5 md:mt-6 text-sm md:text-lg leading-relaxed text-background-200 max-w-2xl">
            聚光台是专注网红爆料的线索征集平台。我们向粉丝与公众开放匿名投稿入口，征集私信截图、聊天记录、带货售后与直播现场线索，逐条核验后再发布，不抢首发、不博眼球。
          </p>

          <div className="mt-7 md:mt-9 flex flex-col sm:flex-row gap-3 md:gap-4">
            <a
              href="#submit"
              className="inline-flex items-center justify-center gap-2 px-6 md:px-8 py-3 md:py-3.5 rounded-md bg-primary-500 text-background-50 font-medium text-sm md:text-base whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-send-plane-fill"></i>
              立即匿名投稿
            </a>
            <a
              href="#process"
              className="inline-flex items-center justify-center gap-2 px-6 md:px-8 py-3 md:py-3.5 rounded-md border border-background-100/50 text-background-50 font-medium text-sm md:text-base whitespace-nowrap hover:bg-background-50/10 transition-colors cursor-pointer"
            >
              <i className="ri-flow-chart"></i>
              了解核验流程
            </a>
          </div>
        </div>

        <dl className="mt-10 md:mt-14 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 max-w-4xl border-t border-background-100/20 pt-6 md:pt-8">
          {stats.map((item) => (
            <div key={item.label} className="flex flex-col gap-1">
              <dt className="font-heading text-2xl md:text-3xl font-bold text-accent-400">{item.value}</dt>
              <dd className="text-xs md:text-sm text-background-200">{item.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}